import React from "react";
import { Card, Select, Space, Typography, Divider, Tag } from "antd";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Title, Text } = Typography;

const ModuloAcceso = ({ modulo, onChange }) => {
  const handleAccesoChange = (value) => {
    onChange({
      ...modulo,
      acceso: value,
      permisos: value === "disponible" ? [] : undefined,
    });
  };

  const handlePermisosChange = (value) => {
    onChange({
      ...modulo,
      permisos: value,
    });
  };

  return (
    <Card
      className="modulo-card"
      style={{
        marginBottom: 16,
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Title level={5} style={{ margin: 0 }}>
            {modulo.descripcion}
          </Title>
          <Tag color={modulo.acceso === "disponible" ? "success" : "default"}>
            {modulo.acceso === "disponible" ? (
              <UnlockOutlined />
            ) : (
              <LockOutlined />
            )}
            {modulo.acceso === "disponible" ? "Disponible" : "Sin acceso"}
          </Tag>
        </div>

        <Divider style={{ margin: "12px 0" }} />

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <Text strong>Nivel de Acceso</Text>
            <Select
              value={modulo.acceso}
              onChange={handleAccesoChange}
              style={{ width: "100%", marginTop: 8 }}
            >
              <Option value="sin_acceso">Sin acceso</Option>
              <Option value="disponible">Disponible</Option>
            </Select>
          </div>

          {modulo.acceso === "disponible" &&
            modulo.permisosCatalogo?.length > 0 && (
              <div>
                <Text strong>Permisos</Text>
                <Select
                  mode="multiple"
                  value={modulo.permisos}
                  onChange={handlePermisosChange}
                  style={{ width: "100%", marginTop: 8 }}
                  placeholder="Seleccione los permisos"
                  optionFilterProp="children"
                >
                  {modulo.permisosCatalogo
                    .filter(
                      (permiso) => permiso && permiso.id && permiso.descripcion
                    )
                    .map((permiso) => (
                      <Option key={`permiso-${permiso.id}`} value={permiso.id}>
                        {permiso.descripcion}
                      </Option>
                    ))}
                </Select>
              </div>
            )}
        </div>
      </Space>
    </Card>
  );
};

export default ModuloAcceso;
